import React, {Fragment } from 'react';
import { ListItem, ListItemText, ListItemIcon, Divider, Button } from '@mui/material';
import { PhoneIphone, SmartScreen } from '@mui/icons-material';
import useLog from '../../hooks/useLog';
import useACS from '../../hooks/useACS';


const FlatDevices = ({devices}) => {

const {LogInfo} = useLog();
const { startCall } = useACS(); 
  

const handleDeviceClick = (device) => {
    LogInfo(`starting call from device list to: ${device.ACSID}`);
    startCall(device);
};
    return (
        <Fragment>
            {devices.map((device, index) => (
                <ListItem 
                    key={device.ACSID} 
                    sx={{ padding:'10px'}}
                >
                    <Button sx={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: 2, width: '80%', display: 'flex', alignItems: 'center', p:'10px' }}   onClick={() => handleDeviceClick(device)}>
                        <ListItemIcon>
                            {device.devicetype==="phone" &&  <PhoneIphone  sx={{color: 'white' }}/>}
                            {device.devicetype==="monitor" &&  <SmartScreen  sx={{color: 'white' }}/>}
                        </ListItemIcon>
                        <ListItemText align="start" sx={{color:'white'}} 
                            slotProps={{
                                sx: {
                                color: 'white',
                                fontWeight: 'light', // Bold font weight
                                fontSize: '20px', // Larger font size
                                },
                            }}>
                            {device.displayName}
                        </ListItemText>
                    </Button>
                </ListItem>
                ))}
                <Divider color="gray"/>
        </Fragment>
    );
};
export default FlatDevices;